export enum RelationshipType {
  Spouse = "spouse",
  Dependent = "dependent",
}

export const MAX_DEPENDENTS = 8;
